import React, { useEffect, useState } from 'react';
import TopBar from './TopBar';
import { API_BASE_URL } from '../config';


const MainContent = ({ isVisible, children }) => {
    const [screenWidth, setScreenWidth] = useState('')
    const [downWebsites, setDownWebsites] = useState([]);
    const [suspiciousWebsites, setSuspiciousWebsites] = useState([]);
    const [confirmingSite, setConfirmingSite] = useState(null); // { url, timeoutId }
    const [downDismissedKey, setDownDismissedKey] = useState(() => localStorage.getItem('banner_down_dismissed') || null);
    const [suspiciousDismissedKey, setSuspiciousDismissedKey] = useState(() => localStorage.getItem('banner_suspicious_dismissed') || null);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        // Fetch down websites
        const fetchDownWebsites = () => {
            fetch(`${API_BASE_URL}/monitoring/down-websites`)
                .then(res => res.json())
                .then(data => {
                    if (data.status === 'ok') {
                        setDownWebsites(data.websites || []);
                    }
                })
                .catch(err => console.error('Error fetching down websites:', err));
        };

        // Fetch suspicious websites (malware detected)
        const fetchSuspiciousWebsites = () => {
            fetch(`${API_BASE_URL}/monitoring/suspicious-websites`)
                .then(res => res.json())
                .then(data => {
                    if (data.status === 'ok') {
                        setSuspiciousWebsites(data.websites || []);
                    }
                })
                .catch(err => console.error('Error fetching suspicious websites:', err));
        };

        fetchDownWebsites();
        fetchSuspiciousWebsites();
        // Refresh down sites every 3 seconds, suspicious every 60s
        const intervalDown = setInterval(fetchDownWebsites, 3000);
        const intervalSuspicious = setInterval(fetchSuspiciousWebsites, 60000);

        return () => {
            window.removeEventListener('resize', handleResize);
            clearInterval(intervalDown);
            clearInterval(intervalSuspicious);
        };
    }, []);

    const handleSiteClick = (site) => {
        const fullUrl = site.startsWith('http') ? site : `https://${site}`;
        window.open(fullUrl, '_blank');

        // After 3 seconds, ask if it's still down
        if (confirmingSite?.timeoutId) clearTimeout(confirmingSite.timeoutId);

        const timeoutId = setTimeout(() => {
            setConfirmingSite({ url: site });
        }, 3000);

        setConfirmingSite({ url: site, timeoutId });
    };

    const handleConfirmCorrection = (site, stillDown) => {
        if (!stillDown) {
            fetch(`${API_BASE_URL}/monitoring/down-websites`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ url: site })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.status === 'ok') {
                        setDownWebsites(prev => prev.filter(s => s !== site));
                    }
                })
                .catch(err => console.error('Error deleting site:', err));
        }
        setConfirmingSite(null);
    };


    const mainContainerStyle = {

        marginLeft: isVisible ? '400px' : '0', // Set margin-left based on visibility
        borderTopLeftRadius: screenWidth > 1200 ? '15px' : '0',

        // Vérif si un user id existe, si c'est le cas, c'est que l'utilisateur est connecté (à X, donc ça cache sur la console pour le ticketing depuis le menu du haut)
        marginTop: localStorage.user_id ? '80' : 0,
        height: localStorage.user_id ? 'calc(100vh - 120px)' : "100vh",

    };

    const downKey = downWebsites.slice().sort().join(',');
    const suspiciousKey = suspiciousWebsites.slice().sort().join(',');
    const showDown = localStorage.user_id && downWebsites.length > 0 && downDismissedKey !== downKey;
    const showSuspicious = localStorage.user_id && suspiciousWebsites.length > 0 && suspiciousDismissedKey !== suspiciousKey;

    const childMainContainerStyle = {
        height: (showDown || showSuspicious) ? 'calc(-120px + 100vh)' : '-webkit-fill-available'
    };

    const closeBtnStyle = {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '2px 6px',
        borderRadius: '4px',
        fontSize: '16px',
        lineHeight: 1,
        opacity: 0.5,
        color: 'inherit',
    };

    return (
        <div className="main-container-composant display-flex flex-direction-column" style={mainContainerStyle}>

            {showSuspicious && (
                <div style={{
                    padding: '15px 20px',
                    background: '#fee2e2',
                    borderLeft: '5px solid #ef4444',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    color: '#991b1b',
                    fontSize: '14px',
                    height: 'unset',
                    overflow: 'hidden',
                    marginBottom: '20px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <span className='display-flex align-items-baseline'>
                            <div className='display-flex align-items-baseline'>
                                <i className="fa-solid fa-shield-virus" style={{ marginRight: '10px', fontSize: '18px' }} />
                                <strong style={{ fontSize: '15px' }}>Sites suspects à contrôler</strong>
                            </div>
                            <span style={{ marginLeft: '10px' }}>Fichiers ou dossiers malveillants détectés</span>
                        </span>
                        <button style={closeBtnStyle} onClick={() => { localStorage.setItem('banner_suspicious_dismissed', suspiciousKey); setSuspiciousDismissedKey(suspiciousKey); }} title="Fermer">✕</button>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', flexDirection: 'row', maxHeight: '120px', overflowY: 'auto', paddingRight: '4px' }}>
                        {suspiciousWebsites.map((site, index) => (
                            <a
                                key={index}
                                href={`/rapport-securite/${encodeURIComponent(site)}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                    background: '#fca5a5',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#991b1b',
                                    textDecoration: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                {site.replace(/^https?:\/\//, '')}
                            </a>
                        ))}
                    </div>
                </div>
            )}

            {showDown && (
                <div style={{
                    padding: '15px 20px',
                    background: '#fefce8',
                    borderLeft: '5px solid #fac72a',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    color: '#854d0e',
                    fontSize: '14px',
                    height: 'unset',
                    overflow: 'hidden',
                    marginBottom: '20px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <span className='display-flex align-items-baseline'>
                            <div className='display-flex align-items-baseline'>
                                <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '10px', fontSize: '18px' }} />
                                <strong style={{ fontSize: '15px' }}>Attention : Certains sites sont indisponibles</strong>
                            </div>
                            <span style={{ marginLeft: '10px' }}>Vérifier si le client est actif</span>
                        </span>
                        <button style={closeBtnStyle} onClick={() => { localStorage.setItem('banner_down_dismissed', downKey); setDownDismissedKey(downKey); }} title="Fermer">✕</button>
                    </div>
                    <div style={{
                        display: 'flex', flexWrap: 'wrap', gap: '8px', flexDirection: 'row',
                        maxHeight: '120px', overflowY: 'auto', paddingRight: '4px'
                    }}>
                        {downWebsites.map((site, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <span style={{
                                    background: '#fde68a',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    width: 'fit-content',

                                    cursor: 'pointer'
                                }} onClick={() => handleSiteClick(site)}>
                                    {site.replace(/^https?:\/\//, '')}
                                </span>

                                {confirmingSite?.url === site && (
                                    <div style={{
                                        fontSize: '11px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        background: '#fff',
                                        padding: '2px 8px',
                                        borderRadius: '4px',
                                        border: '1px solid #fde68a'
                                    }}>
                                        <span>Toujours indisponible ?</span>
                                        <button
                                            onClick={() => handleConfirmCorrection(site, true)}
                                            style={{ border: 'none', background: '#ca8a04', color: '#fff', borderRadius: '3px', padding: '1px 5px', cursor: 'pointer', fontSize: '10px' }}>
                                            OUI
                                        </button>
                                        <button
                                            onClick={() => handleConfirmCorrection(site, false)}
                                            style={{ border: 'none', background: '#10b981', color: '#fff', borderRadius: '3px', padding: '1px 5px', cursor: 'pointer', fontSize: '10px' }}>
                                            NON
                                        </button>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div style={childMainContainerStyle}>
                {children}
            </div>
        </div>
    );
};

export default MainContent;
